document.addEventListener('DOMContentLoaded', function () {
  const CLOSE_DELAY = 250;
  let openItem = null;

  document.querySelectorAll('.mega-menu__item').forEach(function (item) {
    const dropdown = item.querySelector('.mega-menu__dropdown');
    const categories = item.querySelector('.mega-menu__categories');
    const categoryItems = categories ? categories.querySelectorAll('[data-category-index]') : [];
    const categoryPanels = categories ? categories.querySelectorAll('[data-category-panel]') : [];
    let closeTimer;

    function showCategory(index) {
      categoryItems.forEach(function (categoryItem) {
        categoryItem.classList.toggle('mega-menu__sidebar-item--active', categoryItem.dataset.categoryIndex === index);
      });
      categoryPanels.forEach(function (panel) {
        panel.classList.toggle('mega-menu__category-panel--active', panel.dataset.categoryPanel === index);
      });
    }

    function clearOpenState() {
      item.classList.remove('mega-menu__item--open');
      showCategory('0');
      if (openItem === item) {
        openItem = null;
      }
    }

    // Used when switching directly to a different nav item: skips the fade
    // transition so the closing dropdown can't crossfade with the opening
    // one while both occupy the same on-screen position.
    function closeInstantly() {
      clearTimeout(closeTimer);
      if (dropdown) {
        dropdown.style.transition = 'none';
      }
      clearOpenState();
      if (dropdown) {
        void dropdown.offsetHeight;
        dropdown.style.transition = '';
      }
    }

    categoryItems.forEach(function (categoryItem) {
      categoryItem.addEventListener('mouseenter', function () {
        showCategory(categoryItem.dataset.categoryIndex);
      });
    });

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (openItem && openItem !== item) {
        openItem.dispatchEvent(new CustomEvent('megamenu:closeinstantly'));
      }
      item.classList.add('mega-menu__item--open');
      openItem = item;
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(clearOpenState, CLOSE_DELAY);
    });

    item.addEventListener('megamenu:closeinstantly', closeInstantly);
  });
});
